import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const TransactionDetailsProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const createTransactionDetailsRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `ReportCustomEmail/TransactionsByStatus/`, method: 'POST', payload: props, secure: true });
    }, [execute]);


    const value = { data, clearData, createTransactionDetailsRecord };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useTransactionDetailsProviderStore = () => React.useContext(Context);
